"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.isActiveElementPopover = void 0;

var isActiveElementPopover = function isActiveElementPopover() {
  return document.activeElement.dataset.componentName === "PopoverContent";
};

exports.isActiveElementPopover = isActiveElementPopover;
//# sourceMappingURL=isActiveElementPopover.js.map